$(document).ready(function($) {
 // Product descriptions accordion Start
   $('.accordion-body').hide();
  $('.accordion-icon').text('+');
  // toggle the accordion on click
  $('.accordion-header').click(function() {
    $(this).next('.accordion-body').slideToggle();
    $(this).find('.accordion-icon').text(function(_, icon){
      return icon === '+' ? '-' : '+';
    });
  });
$('.benefits-description .accordion-header').click();
  // set the descriptions for the sub-accordions
  if ($('.product-description-container details').html()) {
    $('.benefits-description .description').html($('.product-description-container details').html());
    
  } else {
    $('.benefits-description').hide();
  }
  if ($('.product-description-container  footer').html()) {
    $('.how-it-work-description .description').html($('.product-description-container footer').html());
  } else {
    $('.how-it-work-description').hide();
  }
  if ($('.product-description-container  div.summary').html()) {
    $('.how-better-description .description').html($('.product-description-container div.summary').html());
  } else {
    $('.how-better-description').hide();
  }
  if ($('.product-description-container  main').html()) {
    $('.label-info-description .description').html($('.product-description-container main').html());
  } else {
    $('.label-info-description').hide();
  }



$('.benefits-description-ada .accordion-header').click();
  // set the descriptions for the sub-accordions
   
  if ($('.product-description-container div.product-benefits-copy').html()) {
  $('.benefits-description-ada .description').html($('.product-description-container div.product-benefits-copy').html());
} else {
  $('.benefits-description-ada').hide();
}

if ($('.product-description-container div.product-how-it-work-copy').html()) {
  $('.how-it-work-description-ada .description').html($('.product-description-container div.product-how-it-work-copy').html());
} else {
  $('.how-it-work-description-ada').hide();
}

 if ($('.product-description-container  div.summary-copy').html()) {
    $('.how-better-description-ada .description').html($('.product-description-container div.summary-copy').html());
  } else {
    $('.how-better-description-ada').hide();
  }

if ($('.product-description-container div.product-label-copy').html()) {
  $('.label-info-description-ada .description').html($('.product-description-container div.product-label-copy').html());
} else {
  $('.label-info-description-ada').hide();
}

 // Product descriptions accordion END

// Search
$("#snize-mobile-search-input").on("input", function() {
  $("body .snize-ac-results.snize-ac-results-mobile .snize-ac-results-content #snize-ac-items-container-1.snize-ac-results-list").css("border-bottom", "solid 1px rgba(255,255,255, 0.5)");  
});


// Product's pack and quantity options
if ($('.pack-wrap-box1 a').text().trim() === "" &&
    $('.pack-wrap-box2 a').text().trim() === "" &&
    $('.pack-wrap-box3 a').text().trim() === "") {
  // If all are empty, hide pack-wrap-v
  $('.pack-wrap-v').hide();
} else {
  // If any of them has content, show pack-wrap-v
  $('.pack-wrap-v').show();
}

// Hide individual pack-wrap-box divs if they are empty
$('.pack-wrap-box1 a:empty').parent().hide();
$('.pack-wrap-box2 a:empty').parent().hide();
$('.pack-wrap-box3 a:empty').parent().hide();



$(".accordion-body .description > *:contains('References'), .accordion-body .description > *:contains('Reference'), .accordion-body .description > *:contains('reference'), .accordion-body .description > *:contains('References:'), .accordion-body .description > *:contains('Reference:'), .accordion-body .description > *:contains('reference:')").nextAll("*").hide();
$(".accordion-body .description > *:contains('References'),.accordion-body .description > *:contains('Reference'),.accordion-body .description > *:contains('reference'), .accordion-body .description > *:contains('References:'), .accordion-body .description > *:contains('Reference:'), .accordion-body .description > *:contains('reference:')").addClass("references-active").click(function() {
  $(this).nextAll("*").toggle();
});
  
$(".blog-main--wrapper .rte *").filter(function() {
    var text = $(this).text().trim();
    var regex = /\b(References?|references?):?\b/i;
    return regex.test(text);
}).nextAll("*").hide();

$(".blog-main--wrapper .rte .article-content-v *").filter(function() {
    var text = $(this).text().trim();
    var regex = /\b(References?|references?):?\b/i;
    return regex.test(text);
}).addClass("references-active").click(function() {
    $(this).nextAll("*").toggle();
});
 
// Reviews
$('#judgeme_product_reviews').parent().parent().parent().addClass('bar-adding');

$(function() {
  if($('.product__price .was').length > 0) {
    $('.recharge-widget').hide();
  }
});
  
// After cloning the theme, need to replace the following ID.
$('.product-details--form-wrapper---out-of-stock #shopify-block-b69ee287-601f-4393-bb0d-9c25ac4b5eed').after('<p class="stock out-of-stock">Out of stock</p>');

// Large Menu items deviced in columns
var $menuLink = $('.mega-menu-block .dropdown-submenu:last-child .inner ul.menu-link'); // select the ul element
  var $listItems = $menuLink.children('li'); // select all li elements inside ul
  var itemsPerColumn = 8; // number of items per column
  var totalItems = $listItems.length; // total number of items
  var totalColumns = Math.ceil(totalItems/itemsPerColumn); // total number of columns needed
  var columnClass = 'column'; // class to add to each column ul

  // loop through each column and create a new ul with the class "column"
  for(var i=0; i<totalColumns; i++) {
    $menuLink.append($('<ul>').addClass(columnClass));
  }

  // loop through each item and add it to the appropriate column ul
  $listItems.each(function(index) {
    var columnIndex = Math.floor(index/itemsPerColumn);
    $menuLink.find('.' + columnClass).eq(columnIndex).append($(this));
  });

// Collection description readmore functionality 
var readmore = false;
	var readMoreButtonEle = jQuery(".term-description #readmore-btn");
	var readMoreButtonContainerEle = jQuery(".term-description #readmore-btn-container");
	var readMoreContentEle = jQuery(".term-description #readmore-container");
	var readLessContentClass = ".term-description lesscontent";
	var readMoreText = "Read More";
	var readLessText = "Read Less";
readMoreButtonEle.click(function(){
  if(readmore){
    readMoreButtonEle.text(readMoreText);
    readMoreContentEle.addClass(readLessContentClass);
    readMoreButtonContainerEle.addClass(readLessContentClass);
		}else{
    readMoreButtonEle.text(readLessText);
    readMoreContentEle.removeClass(readLessContentClass);
    readMoreButtonContainerEle.removeClass(readLessContentClass);
		}
    readmore = !readmore;
  	});
  
 // remove all classes first
$(".blog-home-section-v").removeClass("show-nmn-root show-nmn-101-root");

// Product page faq adjustments
$('.accordion-content').wrapAll('<div class="product-page-faqs"></div>');

// add appropriate class based on URL
if (window.location.href.toLowerCase().indexOf("blogs/control-how-you-age/tagged/nmn-101") > -1) { 
  $(".blog-home-section-v").addClass("show-nmn-101-root");
} else if (window.location.href.toLowerCase().indexOf("blogs/control-how-you-age/tagged/nmn") > -1) {
  $(".blog-home-section-v").addClass("show-nmn-root");
}
  
$(".article-single-page-r").parent().addClass("article-single-page-background");
$('.selector-wrapper, .paymentButtonsWrapper').wrapAll('<div class="top-border-new"></div>');
$(".reviews-section-subtitle").insertAfter("#judgeme_product_reviews .jdgm-rev-widg__title"); // loop through each money element
  $("#template--collection .money").each(function() {
    // check if the next sibling element has class "sale-price"
    if ($(this).next().hasClass("sale-price")) {
      // if yes, change the text color of money element to orange
      $(this).css("color", "#30e61c");
      $().css("margin-right","15px");
    }
  });
$(".guarantee-free-shipping").insertAfter("#PageContainer #AddToCartForm");


//On scroll functionality 
$(window).scroll(function() {
  if ($(this).scrollTop() > 15) {
    $('#shopify-section-header .header-section--wrapper').addClass('fix-header-v');
     $('.wrapper.main-content.page-main--wrapper').css('margin-top', '110px');
  } else {
    $('#shopify-section-header .header-section--wrapper').removeClass('fix-header-v');
     $('.wrapper.main-content.page-main--wrapper').css('margin-top', '0');
  }
});

// Collection page product grid text limit  
$('#PageContainer .product-grid--title a').each(function(){
  if($(this).text().length > 85){
    $(this).addClass('product-grid-char-v');
  }
});

// Collection page on sale product classes
$('#PageContainer .product-grid--price a').each(function() {
        // Check if it contains a .money element with .sale-price class
        const hasSalePrice = $(this).find('.money.sale-price').length > 0;

        // Add the 'on-sale' class if it's on sale, otherwise remove it
        if (hasSalePrice) {
            $(this).addClass('on-sale-v');
        } else {
            $(this).removeClass('on-sale-v');
        }
    });

// Product detail functionality
$(".pack-wrap-v").insertBefore(".form-vertical #AddToCartForm #rc_container");
$(".top-border-new").parent("div").addClass("quantity-wrap-v");
  $("#PageContainer .product-detail-v div.rc_popup ").insertAfter("#PageContainer .product-detail-v .guarantee-free-shipping");

 $('.rc_label__discount').each(function() {
    var text = $(this).text();
    text = text.replace(/[^\d%]/g, ''); // This will keep only digits and %
    $(this).text(text);
  });

  setInterval(function () {
if ($(".swiper-slide.product-medias__primary").find("iframe").length > 0) {
$(".product-detail-v .product-single-wrapper").addClass("iframe-media-v");
}
  else{
$(".product-detail-v .product-single-wrapper").removeClass("iframe-media-v");
}

$(".snize-ac-results .snize-ac-results-content .snize-ac-results-list .snize-view-link, .snize-ac-results .snize-ac-results-content .snize-ac-results-list .snize-view-link b").each(function() {
    var text = $(this).text();
    var words = text.split(' ');

    if (words.length > 12) {
        var truncatedText = words.slice(0, 12).join(' ') + '...';
        $(this).text(truncatedText);
    }
});
$(".snize-product").each(function() {
    // Check if .snize-discounted-price exists under .snize-product
    var discountedPriceExists = $(this).find('.snize-discounted-price').length > 0;

    // Check if SALE div has already been added
    var saleDivAdded = $(this).find('.snize-product-label.snize-product-discount-label').length > 0;

    // If .snize-discounted-price exists and SALE div has not been added, append the SALE div
    if (discountedPriceExists && !saleDivAdded) {
        $(this).append('<div class="snize-product-label snize-product-discount-label" style="background: #000000; color: #FFFFFF">SALE</div>');
    }
});
  
   $("#PageContainer .product-details-wrapper div.rc_popup").hide();

  if ($('.rc_block__type__autodeliver').hasClass('rc_block__type--active')) {
    
 // $("#PageContainer .product-details-wrapper div.rc_popup").show();
  } else {
    // If it doesn't have the class, change the text to "ADD TO CART"
    $('#AddToCart').text("ADD TO CART");
  $("#PageContainer .product-details-wrapper div.rc_popup").hide();
  } 

}, 100);

 
// After unpublished the subscription widget change 2 - COMMMENT the below lines of code Start
 
 if ($('.product-detail-v .rc_label__discount').length > 0) {
    $("#ProductPrice").hide();
  } else {
    $("#ProductPrice").show();
    $("#PageContainer .rc_block.rc_block__type.rc_block__type--active label.rc_label.rc_label__autodeliver").text("Subscribe");
  }
 
// After unpublished the subscription widget change 2 - ADD the below lines of code END
  
  //Gift Card
 if ($('#PageContainer .prohealth-gift-card').length > 0) {
        $('.footer-wrapper').addClass('prohealth-gift-footer');
    } else {
        $('.footer-wrapper').removeClass('prohealth-gift-footer');
    } 
  $("#top_links_wrapper").on("click", function() {
  $(".desktop-nav-vr").addClass("menu-bar-vr");
  $(".desktop-nav-vr").addClass("body-gray-out");
  $("#searchform input[type='text']").css("pointer-events", "none");

var prodTitleR = $('.product-details-wrapper .product-details-product-title').text();
$('.product-details-wrapper .out-of-stock').attr('aria-label', prodTitleR);


// After unpublished the subscription widget change 3 - ADD the below lines of code Start
//if ($("#rc_container").css("display") === "none") {
    //    $(".rc_popup__hover").css("display", "none");
    //} else {
      //  $(".rc_popup__hover").css("display", "block");
//}
// After unpublished the subscription widget change 3 - ADD the above lines of code END
    
});


  
 $("#AccessibleNav .site-nav--has-dropdown, #AccessibleNav .site-nav--has-dropdown > .site-nav__link, #AccessibleNav .site-nav__dropdown > .site-nav--has-dropdown > .site-nav__link").on("click", function(event) {
  // Prevent the default behavior for specific paths
  if ($(this).is(".site-nav--has-dropdown > .site-nav__link, .site-nav__dropdown > .site-nav--has-dropdown > .site-nav__link")) {
    event.preventDefault();
  }
   
  // Toggle the class on the clicked submenu
  var submenu = $(this).find(".site-nav__dropdown");
  submenu.addClass("nav-click-vr");

  // Hide other submenus
  $("#AccessibleNav .site-nav__dropdown").not(submenu).removeClass("nav-click-vr");

    
});
 

// Add a click event to the document to close the submenu when clicking outside
$(document).on("click", function(e) {
  var target = $(e.target);
  // Check if the clicked element is not a part of the submenu or its trigger
  if (!target.closest("#AccessibleNav").length) {
    $("#AccessibleNav .site-nav__dropdown").removeClass("nav-click-vr");
    $(".desktop-nav-vr").removeClass("menu-bar-vr");
    $(".desktop-nav-vr").removeClass("body-gray-out");
    $("#AccessibleNav .site-nav__dropdown .site-nav__dropdown").removeClass("nav-click-vr2");
    $("#PageContainer ul.site-nav__dropdown .site-nav__subdropdown").removeClass("nav-click-vr2");
     $(".js-drawer-open #PageContainer .sub-menu-active#NavDrawer .site-nav__subdropdown.nav-click-vr2").removeClass("subdrawerOut");
    $("#NavDrawer").removeClass("sub-menu-active");
    $("#searchform input[type='text']").css("pointer-events", "unset");
     //$("#AccessibleNav .desktop-nav-vr > .site-nav--has-dropdown").removeClass("width-100vm");
  }
});

$("#AccessibleNav .site-nav--has-dropdown .site-nav--has-dropdown").on("click", function() {
    var submenu2 = $(this).find(".site-nav__subdropdown");
    // add the class on the clicked submenu2
    submenu2.addClass("nav-click-vr2");
 
    if (submenu2.hasClass("nav-click-vr2")) {
        $("#NavDrawer").addClass("sub-menu-active");
    } else {
        $("#NavDrawer").removeClass("sub-menu-active");
    }
  
    // Hide other submenus
    $("#AccessibleNav .site-nav__dropdown .site-nav__subdropdown").not(submenu2).removeClass("nav-click-vr2");
   $(".js-drawer-open #PageContainer .sub-menu-active#NavDrawer .site-nav__subdropdown.nav-click-vr2").removeClass("subdrawerOut");
    $("#PageContainer #AccessibleNav .site-nav__subdropdown").removeClass("slideAnimation_v");
  

 
});
  
// Add a click event to the document to close the submenu2 when clicking outside
$(document).on("click", function(e) {
  var target = $(e.target);
  // Check if the clicked element is not a part of the submenu2 or its trigger
  if (!target.closest("#AccessibleNav").length) {
  $("#AccessibleNav .site-nav__dropdown .site-nav__dropdown").removeClass("nav-click-vr2");
     $(".js-drawer-open #PageContainer .sub-menu-active#NavDrawer .site-nav__subdropdown.nav-click-vr2").removeClass("subdrawerOut");
    
  $("#AccessibleNav .site-nav__dropdown").removeClass("nav-click-vr");
  $(".desktop-nav-vr").removeClass("menu-bar-vr");
  $(".desktop-nav-vr").removeClass("body-gray-out");
  $("#searchform input[type='text']").css("pointer-events", "unset");
  $("#PageContainer ul.site-nav__dropdown .site-nav__subdropdown").removeClass("nav-click-vr2");
  //$("#AccessibleNav .desktop-nav-vr > .site-nav--has-dropdown").removeClass("width-100vm");
     $(".js-drawer-open #PageContainer .sub-menu-active#NavDrawer .site-nav__subdropdown.nav-click-vr2").removeClass("subdrawerOut");
}

if ($(window).width() > 819) {
  if (!$(".desktop-nav-vr").hasClass("body-gray-out")) {
  $(".site-nav--has-dropdown").removeClass("width-100vm");
  
    
}
if ($(".desktop-nav-vr").hasClass("body-gray-out")) {
    $("html body").css("overflow-y", "hidden");
}
  else{$("html body").css("overflow-y", "auto");}
}
  
});

$(".mega-menu .site-nav__dropdown li.dropdown-submenu:nth-child(2) > .inner.mega-menu--image-wrapper").insertAfter("ul.site-nav__dropdown > li.menu-drawer-vr").wrap("<li class='add-module-desktop'></li>");
$(".mega-menu .site-nav__dropdown li.dropdown-submenu:last-child > .inner.mega-menu--image-wrapper").insertAfter("ul.site-nav__dropdown > li.menu-drawer-vr").wrap("<li class='add-module-mobile'></li>"); 

$("#AccessibleNav .desktop-nav-vr > .site-nav--has-dropdown").click(function() {

  // Remove the class from all elements
  $("#AccessibleNav .desktop-nav-vr > .site-nav--has-dropdown").removeClass("width-100vm");
 
  // Add the class to the clicked element if the condition is met
  var $dropdown = $(this).find('.site-nav__dropdown');
  if ($dropdown.hasClass("nav-click-vr")) {
    $(this).addClass("width-100vm");
  }


});

$("#AccessibleNav .desktop-nav-vr > .site-nav--has-dropdown:nth-child(2)").click(function() {
 
  // Remove the class from specific descendants
  $("#AccessibleNav .desktop-nav-vr > .site-nav--has-dropdown .site-nav__subdropdown").removeClass("nav-click-vr2");
 $(".js-drawer-open #PageContainer .sub-menu-active#NavDrawer .site-nav__subdropdown.nav-click-vr2").removeClass("subdrawerOut");
   
});
 


$("#PageContainer .mobile-menu--close-btn").click(function() {
  $("#AccessibleNav .desktop-nav-vr > .site-nav--has-dropdown").removeClass("width-100vm");   
});

$("#PageContainer .tab-nav-v .site-nav--mobile > button").click(function() {
 $("#AccessibleNav .desktop-nav-vr > .site-nav--has-dropdown:first-child").addClass("width-100vm");  
});
 

if ($(window).width() > 819 && !(/Mobi|Android/i.test(navigator.userAgent))) {
  $("#PageContainer .site-nav__dropdown .site-nav--has-dropdown ul.site-nav__subdropdown").each(function() {
    var $ul = $(this);
    var liCount = $ul.find("li").length;

    // Remove existing classes
    $ul.removeClass("subdropdown-vr-col-2 subdropdown-vr-col-multi ul-three-column ul-two-column");

    if (liCount > 33) {
      $ul.addClass("subdropdown-vr-col-multi");

      var itemsPerColumn = Math.ceil(liCount / 3); // Ensure an even distribution

      // Wrap every itemsPerColumn li tags in a new ul with class "ul-three-column"
      var $lis = $ul.find("li");
      for (var i = 0; i < liCount; i += itemsPerColumn) {
        $lis.slice(i, i + itemsPerColumn).wrapAll('<ul class="ul-three-column"></ul>');
      }

      // Wrap the ul with class "ul-three-column" in a parent div with class "parent-div"
       $ul.find('.ul-three-column').wrapAll('<div class="parent-three-column"></div>');
    } else if (liCount > 20) {
      $ul.addClass("subdropdown-vr-col-multi");

      var itemsPerColumn = Math.ceil(liCount / 3); // Ensure an even distribution

      // Wrap every itemsPerColumn li tags in a new ul with class "ul-three-column"
      var $lis = $ul.find("li");
      for (var i = 0; i < liCount; i += itemsPerColumn) {
        $lis.slice(i, i + itemsPerColumn).wrapAll('<ul class="ul-three-column"></ul>');
      }
    } else if (liCount > 10) {
      $ul.addClass("subdropdown-vr-col-2");

      var itemsPerColumn = Math.ceil(liCount / 2); // Ensure an even distribution

      // Wrap every itemsPerColumn li tags in a new ul with class "ul-two-column"
      var $lis = $ul.find("li");
      for (var i = 0; i < liCount; i += itemsPerColumn) {
        $lis.slice(i, i + itemsPerColumn).wrapAll('<ul class="ul-two-column"></ul>');
      }
    }
  });

  if (!$(".desktop-nav-vr").hasClass("body-gray-out")) {
    $(".site-nav--has-dropdown").removeClass("width-100vm");
  }
}



if ($(window).width() < 819) {
$("#AccessibleNav .desktop-nav-vr > .site-nav--has-dropdown:first-child").addClass("width-100vm");
}

$("#AccessibleNav .site-nav--has-dropdown .site-nav--has-dropdown .site-nav__subdropdown").addClass("slideAnimation_v");

 
 // Function to set the viewport meta tag
function setViewport() {
    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (isIOS) {
        // For iOS devices
        document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    } else {
        // For other devices
        document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=2.0, user-scalable=1');
    }
}

// Call the function on page load
setViewport();


});

(function() {
  // Check if the ul inside .benefit-icons-v has any li elements - Product pages
  const ulElement = document.querySelector('.benefit-icons-v ul');
  const liElements = ulElement.querySelectorAll('li');
 // Add or remove the "benefit-icons-blank" class based on liElements presence
  const divElement = document.querySelector('.benefit-icons-v');
  if (liElements.length === 0) {
    divElement.classList.add('benefit-icons-blank');
  } else {
    divElement.classList.remove('benefit-icons-blank');
  }
})();
  document.addEventListener('DOMContentLoaded', function() {
    $('.site-nav--has-dropdown > a').on('click', function(e) {
      e.preventDefault();

      // Close other open dropdowns
      $('.site-nav--has-dropdown').not($(this).parent()).removeClass('dropdown-open');
      
      // Toggle the dropdown for the clicked item
      $(this).parent().toggleClass('dropdown-open');
    });

    // Close dropdowns when clicking outside
    $(document).on('click', function(e) {
      if (!$(e.target).closest('.site-nav--has-dropdown').length) {
        $('.site-nav--has-dropdown').removeClass('dropdown-open');
        $("#AccessibleNav .desktop-nav-vr > .site-nav--has-dropdown").removeClass("width-100vm");
      }
    });

    
  });

  /***** Recharge code and updates by Dolly 10th jan 2024 *****/
$(document).ready(function($) {
    // show the element with id "ProductPrice"
    $("#ProductPrice").show();
    $("#PageContainer #AddToCartForm .selector-wrapper, #PageContainer #AddToCartForm .paymentButtonsWrapper").show();
  
   /*Recharge subscription click*/
 // Event listener for clicks on elements with the class "subscription-radio"
$(document).on("click", ".subscription-radio", function() {
    // Delay the execution by 300 milliseconds using setTimeout to ensure proper DOM manipulation
    
    setTimeout(function() {
      
      // Append the "rc-selling-plans" to the end of "rc-radio--active.subscription-radio" if not already present
      if ($('.rc-radio--active.subscription-radio').children('.rc-selling-plans').length == 0) {
        $('.rc-radio--active.subscription-radio').append($('.rc-selling-plans'));
      }
      
      // Get the selected value from the dropdown with class "rc-selling-plans-dropdown__select"
      var planID = $(".rc-selling-plans-dropdown__select").val();
      
      // Set the value of the input with the name "selling_plan" to the selected planID
      $("[name='selling_plan']").val(planID);
      
      // Hide elements with class "percentage" that contain the text "undefined"
      $('.percentage:contains("undefined")').css('display', 'none');

      // Toggle visibility of the subscription details based on the active radio button
      if ($(".onetime-radio").hasClass("rc-radio--active")) {
        $(".rc-subscription-details").hide();
      }

      if ($(".subscription-radio").hasClass("rc-radio--active")) {
        $(".rc-subscription-details").show();
      }
      
      // Event listener for changes in the input elements within the "rc-widget" container
      $(".rc-widget input.rc-radio__input").change(function() {
        if ($(".onetime-radio").hasClass("rc-radio--active")) {
          $(".rc-subscription-details").hide();
        } else if ($(".subscription-radio").hasClass("rc-radio--active")) {
          $(".rc-subscription-details").show();
        } else {
          $(".rc-subscription-details").hide();
        }
      });

      // Show specified elements in the page container
      $("#PageContainer #AddToCartForm .selector-wrapper, #PageContainer #AddToCartForm .paymentButtonsWrapper").show();
      
    }, 300);
});

// Event listener for clicks on elements with the class "onetime-radio"
$(document).on("click", ".onetime-radio", function() {
    // Change the content of the element with id "AddToCart" to "ADD TO CART"
    $("#AddToCart").html("ADD TO CART");
    // Clear the value of the input with the name "selling_plan"
    $("[name='selling_plan']").val("");
});

// Event listener for changes in elements with the class "rc-selling-plans-dropdown__select"
$(document).on("change", ".rc-selling-plans-dropdown__select", function() {
    // Get the selected value from the dropdown with class "rc-selling-plans-dropdown__select"
    var planID = $(".rc-selling-plans-dropdown__select").val();
    // Set the value of the input with the name "selling_plan" to the selected planID
    $("[name='selling_plan']").val(planID);
});


  /* Oberserver  -- Subscription Plan ID update */
  var targetNodes = $(".recharge-subscription-widget");
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  var bundleObserver = new MutationObserver(mutationHandler);
  var obsConfig = {
    childList: true,
    characterData: true,
    attributes: true,
    subtree: true
  };

  targetNodes.each(function() {
    bundleObserver.observe(this, obsConfig);
  });

 // Mutation handler function that processes mutation records
function mutationHandler(mutationRecords) {

    // Iterate through each mutation record
    mutationRecords.forEach(function(mutation) {

        // Check if the mutation type is "childList"
        if (mutation.type == "childList") {

            // Iterate over added nodes
            $(mutation.addedNodes).each(function() {

                // Check if the current node has the class ".rc-widget"
                if ($(this).hasClass("rc-widget")) {
                       // If recharge exists, show the element with id "ProductPrice"
                      $("#ProductPrice").hide();
                      if ($(".product-detail-v #AddToCartForm .product-page--sale-badge").length > 0) {
                        $("#PageContainer #ProductPrice").show();
                      }
                    // Add a new span above the "rc-widget" with text "Purchase Type" and class "small-p"
                    $("<span class='small-p'>").text("Purchase Type").insertBefore(this);

                    // Fire the click event for the class "rc-radio subscription-radio"
                    $(this).find('.rc-radio.subscription-radio').click();

                    // Extract information from "rc-radio__subscription" class
                    var subscriptionLabel = $(this).find('.rc-radio__subscription');

                    // Directly extract the text content without decoding
                    var subscriptionText = subscriptionLabel.text().trim();

                    // Split the text content into "Subscribe & Save" and "10%"
                    var splitText = subscriptionText.split(' ');

                    // Extracted values
                    var subscribeAndSave = splitText[0];
                    var percentageValue = splitText[3];

                    // Update the HTML content of the subscription radio label with extracted values
                    var subcribePrice = $(".subscription-radio").find(".rc-radio__price").html();
                    $(".subscription-radio").find(".rc-radio__label").html('<span class="rc-radio__price">' + subcribePrice + '</span><span class="subscribe-text"><span>Subscribe & Save</span><span class="percentage">' + percentageValue + '</span></span>');

                    // Onetime price split
                    var oneTimeSplit = $(".onetime-radio").find(".rc-radio__label").html().trim().split(' ');
                    var oneTimePrice = oneTimeSplit[2];
                    $(".onetime-radio").find(".rc-radio__label").html('<span class="rc-radio__price">' + oneTimePrice + '</span><span class="subscribe-text">One-time Purchase</span>');

                    // Check if the product has a sale tag; if it does, default to one-time purchase
                    if ($(".product-detail-v #AddToCartForm .product-page--sale-badge").length > 0) {

                        // Delay the click event for the onetime-radio by 500 milliseconds
                        setTimeout(function() {
                            $(".onetime-radio").click();
                        }, 500);
                    } else {
                        // Move ".rc-subscription-details" to '.my-section.guarantee-free-shipping' and click on the active radio
                        $(".rc-subscription-details").detach().appendTo('.my-section.guarantee-free-shipping');
                        $(".rc-radio--active").click();
                    }

                    // Disconnect the observer after processing the mutation
                    bundleObserver.disconnect();
                }
            });
        }
    });
}


// Set a timeout function with a delay of 50 milliseconds
setTimeout(function() {

    // Check if the specified condition is met (product has a sale badge)
    if ($(".product-detail-v #AddToCartForm .product-page--sale-badge").length > 0) {

        // Hide the recharge subscription widget and subscription details for products on sale
        $(".product-detail-v #AddToCartForm .recharge-subscription-widget, .product-detail-v #AddToCartForm .rc-subscription-details").hide();
      
    }

    // Show the selector wrapper and payment buttons wrapper in the AddToCartForm
    $("#PageContainer #AddToCartForm .selector-wrapper, #PageContainer #AddToCartForm .paymentButtonsWrapper").show();

}, 100);

});


//Check if we have pharma product then hide guarantee-free-shipping
//if not product template this script did not work
const productTemplate = document.querySelector('.template-product');
if(productTemplate){
  const hideShipping = document.querySelector('[data-hide-shipping]');
  const findShippingInterval = setInterval(() => {
    const freeShippingBlock = document.querySelector('.guarantee-free-shipping');
    if(freeShippingBlock){
      const attributeValue = hideShipping.getAttribute('data-hide-shipping');
      freeShippingBlock.style.display = attributeValue === 'false' ? 'block' : 'none';
      clearInterval(findShippingInterval);
    }
  }, 100);
}